package org.example.zone360.pages.coachDetails.coachAssistAi

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import org.example.zone360.utils.coachBotStreamRequest
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.generateChatbotReport
import kotlinx.browser.document
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.CyclingThinkingIndicator
import org.example.zone360.components.DownloadPdfRequest
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.AdminBotRequest
import org.example.zone360.models.ChatBotMessage
import org.example.zone360.models.ConversationHistory
import org.example.zone360.models.DashboardChatState
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.pages.coachDetails.coachAssistAi.AssistAIConstants.quickCoachReportQuestions
import org.example.zone360.pages.players_Details.assistAI.ExpandableContent
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Config
import org.example.zone360.utils.Constants
import org.example.zone360.utils.MarkdownRenderer
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedLanguage
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.outline
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLTextAreaElement
import org.example.zone360.utils.updateUserData
import kotlin.coroutines.cancellation.CancellationException

@Composable
fun CoachAssistAI(
    onDismiss: () -> Unit = {},
    toastMessage: (String) -> Unit = {},
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    scrollContainerId: String,
    messageInputId: String,
    userId: String,
    selectedSessionType: SelectedData,
    selectedLanguage: SelectedLanguage,
    getCoachInfo: GetSingleCoachData,
    showOverlay: Boolean,
    onShowOverlayChange: (Boolean) -> Unit,
    sessionList: List<GetSessionsData>,
    playersList: List<GetPlayerData>,
    subscriptionPopup: (Boolean) -> Unit,
    // ── New: popup (fullscreen) + dashboard-expand support, same as DashboardChatbot ──
    onExpandToggle: () -> Unit = {},
    isChatOpen: Boolean = false,
    isDashboardExpanded: Boolean = false,
    onDashboardExpandToggle: () -> Unit = {},
    chatMessages: DashboardChatState
) {
    val scope = rememberCoroutineScope()
    var chatBotResponse by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }
//    val getChatBotMessage = remember { mutableStateListOf<ChatBotMessage>() }
    var questionLimitReached by remember { mutableStateOf(false) }
    var questionCount by remember { mutableStateOf(getCoachInfo.botQuestionAsked) }
    var expandedCategory by remember { mutableStateOf<String?>(null) }
    var userInput by remember { mutableStateOf("") }
    var isButtonLoading by chatMessages::isButtonLoading
    var isQuickActionLoading by chatMessages::isQuickActionLoading
    val getChatBotMessage = chatMessages.messages

    // Below MD → stack quick-actions below the chat panel
    val isMobile = breakpoint < Breakpoint.MD

    fun updateQuestionCount(newCount: Int) {
        scope.launch {
            try {
                val updatedCoachInfo = getCoachInfo.copy(botQuestionAsked = newCount)
                updateUserData(Json.encodeToString(updatedCoachInfo))
            } catch (e: Exception) {
                console.error("Failed to update botQuestionAsked count: $e")
            }
        }
    }

    fun isPaid(status: String): Boolean = status in setOf(Strings.PAID, Strings.SUCCEEDED)

    val coachHasReachedLimit = getCoachInfo.botQuestionAsked >= Config.allowedQuestions
    val isIndependentCoach = getCoachInfo.organization == Strings.INDEPENDENT
    val isCoachPaid = isPaid(getCoachInfo.payment.checkout.status)
    val isCoachUnexpired = isPaymentActive(getCoachInfo.payment.checkout.expiredOn)

    val (isClubPaid, isClubUnexpired) = when (AppGlobal.userData.role) {
        Strings.ADMIN -> isPaid(AppGlobal.userData.payment.checkout.status) to
                isPaymentActive(AppGlobal.userData.payment.checkout.expiredOn)

        else -> isPaid(AppGlobal.userData.clubPayment.status) to
                isPaymentActive(AppGlobal.userData.clubPayment.expiredOn)
    }

    val notAllowedCondition = when {
        isIndependentCoach -> (!isCoachPaid || !isCoachUnexpired) && coachHasReachedLimit
        else -> (!isClubPaid || !isClubUnexpired) && coachHasReachedLimit
    }

    val allowQuestionCount = if (isIndependentCoach) {
        !isCoachPaid || !isCoachUnexpired
    } else {
        !isClubPaid || !isClubUnexpired
    }

    val overLayOptions = showOverlay || notAllowedCondition

    if (getCoachInfo.payment.checkout.status != Strings.PAID) {
        LaunchedEffect(questionCount) {
            if (questionCount > Config.allowedQuestions) {
                questionLimitReached = true
                subscriptionPopup(true)
                expandedCategory = null
                onShowOverlayChange(true)
                (document.getElementById(messageInputId) as? HTMLTextAreaElement)?.value = ""
            }
        }
    }

    LaunchedEffect(
        getChatBotMessage.lastOrNull()?.message?.length,
        getChatBotMessage.lastOrNull()?.status
    ) {
        kotlinx.coroutines.delay(50)

        val container = document.getElementById(scrollContainerId) as? HTMLElement
        container?.scrollTop = container?.scrollHeight?.toDouble() ?: 0.0
    }


    fun handleUserMessage(
        message: String,
        isFromQuickAction: Boolean = false,
        forceReport: Boolean = false,
        displayTitle: String? = null
    ) {
        if (message.isBlank() || overLayOptions || isLoading) return

        if ((isFromQuickAction && isQuickActionLoading) ||
            (!isFromQuickAction && isButtonLoading)
        ) return

        scope.launch {

            if (isFromQuickAction) {
                isQuickActionLoading = true
            } else {
                isButtonLoading = true
            }

            if (allowQuestionCount) {
                questionCount += 1
                updateQuestionCount(questionCount)
            }

            if (!isFromQuickAction) {
                val inputField =
                    document.getElementById(messageInputId) as? HTMLTextAreaElement
                inputField?.value = ""
                userInput = ""
            }

            var botIndex = -1   // ✅ outer scope declare for catch access

            try {
                getChatBotMessage.add(
                    ChatBotMessage(
                        message = message,
                        displayMessage = if (forceReport) displayTitle else null,
                        isUserMessage = true
                    )
                )

                val history = getChatBotMessage
                    .dropLast(1)
                    .takeLast(Config.ALLOWED_CONVERSATION_HISTORY)
                    .map {
                        ConversationHistory(
                            role = if (it.isUserMessage) "user" else "assistant",
                            content = it.message
                        )
                    }

                val payload = AdminBotRequest(
                    query = message,
                    role = "coach",
                    userId = getCoachInfo.id,
                    organization = getCoachInfo.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    generatePdf = forceReport,
                    conversationHistory = history.ifEmpty { null }
                )

                getChatBotMessage.add(
                    ChatBotMessage(
                        isUserMessage = false,
                        message = "",
                        status = "Thinking",
                        isThinking = true
                    )
                )

                botIndex = getChatBotMessage.lastIndex

                coachBotStreamRequest(
                    payload = payload,
                    onEvent = { event ->
                        val current = getChatBotMessage[botIndex]
                        when (event.type) {
                            "thinking" -> {
                                if (current.status.isBlank() && current.message.isBlank()) {
                                    getChatBotMessage[botIndex] = current.copy(
                                        status = "Thinking",
                                        isThinking = true
                                    )
                                }
                            }

                            "tool" -> {
                                val toolStatus = when (event.name) {
                                    "list_coaches" -> "Searching coaches"
                                    "get_club_keywords" -> "Loading club keywords"
                                    "get_coach_keywords" -> "Analyzing coach sessions"
                                    else -> "Using ${event.name}"
                                }
                                getChatBotMessage[botIndex] = current.copy(
                                    status = toolStatus,
                                    isThinking = true
                                )
                            }

                            "token" -> {
                                val latest = getChatBotMessage[botIndex]
                                getChatBotMessage[botIndex] = latest.copy(
                                    status = "",
                                    isThinking = false,
                                    isStreaming = true,
                                    message = latest.message + event.content.orEmpty()
                                )
                            }

                            "done" -> {
                                val latest = getChatBotMessage[botIndex]
                                getChatBotMessage[botIndex] = latest.copy(
                                    status = "",
                                    isThinking = false,
                                    isStreaming = false,
                                    pdfPayload = event.pdfPayload,
                                    pdfType = event.pdfType
                                )
                            }
                        }
                    },

                    onError = { errorMsg ->

                        val friendlyMessage = try {
                            val errorJson = Json.parseToJsonElement(errorMsg.trim()).jsonObject

                            when (errorJson["error"]?.jsonPrimitive?.content) {

                                "subscription_required" -> {

                                    // Keep UI in sync with backend
                                    questionLimitReached = true
                                    onShowOverlayChange(true)
                                    "Free questions limit reached. Please subscribe to continue using AssistAI."
                                }

                                else -> errorMsg
                            }

                        } catch (e: Exception) {
                            errorMsg.ifBlank { "Something went wrong" }
                        }

                        if (botIndex >= 0 && botIndex < getChatBotMessage.size) {
                            val current = getChatBotMessage[botIndex]

                            getChatBotMessage[botIndex] = current.copy(
                                status = "",
                                isThinking = false,
                                isStreaming = false,
                                message = friendlyMessage
                            )
                        }

                        if (isFromQuickAction) {
                            isQuickActionLoading = false
                        } else {
                            isButtonLoading = false
                        }
                    }
                )

            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Throwable) {
                if (botIndex >= 0 && botIndex < getChatBotMessage.size) {
                    val current = getChatBotMessage[botIndex]
                    getChatBotMessage[botIndex] = current.copy(
                        status = "",
                        isThinking = false,
                        isStreaming = false,
                        message = "Something went wrong"
                    )
                } else {
                    getChatBotMessage.add(
                        ChatBotMessage(message = "Something went wrong", isUserMessage = false)
                    )
                }
            } finally {
                if (isFromQuickAction) {
                    isQuickActionLoading = false
                } else {
                    isButtonLoading = false
                }
            }
        }
    }

    // ── Shared UI blocks ────────────────────────────────────────────────────

    @Composable
    fun Header() {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Box(
                modifier = Modifier
                    .size(52.px)
                    .borderRadius(100.px)
                    .border(width = 1.px, color = Colors.LightGray, style = LineStyle.Solid)
                    .backgroundColor(Colors.LightGray),
                contentAlignment = Alignment.Center
            ) {
                Image(
                    src = Res.Images.assistAiMatt,
                    modifier = Modifier.size(52.px).borderRadius(100.px)
                )
            }
            CustomSpacer(20.px)
            Column {
                FieldTitleTextNormalSimple(text = "AssistAI", fontWeight = 600, fontSize = 20.px)
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Box(
                        modifier = Modifier.width(6.px).height(6.px)
                            .borderRadius(100.percent)
                            .backgroundColor(Palette.GreenShadeColor.rgbLight)
                    )
                    FieldTitleTextNormalSimple(
                        text = "Online",
                        fontWeight = 500,
                        fontSize = 14.px,
                        color = Palette.GreenShadeColor.rgbLight,
                        marginLeft = 5.px
                    )
                }
            }

        }
    }

    @Composable
    fun ChatMessages(chatHeight: CSSLengthOrPercentageNumericValue) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(chatHeight)
                .margin(topBottom = 15.px)
                .position(Position.Relative)
                .transition(
                    Transition.of(
                        property = "height",  // ← SPECIFY PROPERTY
                        duration = 400.ms,
                        timingFunction = AnimationTimingFunction.EaseInOut
                    )
                )
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(10.px)
                    .height(chatHeight)
                    .transition(
                        Transition.of(
                            property = "height",  // ← SPECIFY PROPERTY
                            duration = 300.ms,
                            timingFunction = AnimationTimingFunction.EaseInOut
                        )
                    )
                    .id(scrollContainerId)
                    .overflow(Overflow.Auto)
                    .thenIf(breakpoint < Breakpoint.MD) {
                        Modifier
                            .borderTop(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.textFieldBorderColor.rgb
                            )
                            .borderBottom(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.textFieldBorderColor.rgb
                            )
                    }
            ) {
                if (getChatBotMessage.isEmpty() && !isLoading && !isButtonLoading) {
                    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        FieldTitleTextNormalSimple(
                            text = "Chat with the bot to ask questions, or explore features with Quick Assist.",
                            fontSize = 14.px,
                            color = Colors.Gray,
                            textAlign = TextAlign.Center,
                        )
                    }
                } else {
                    getChatBotMessage.forEach { msg ->
                        var isDownloading by remember { mutableStateOf(false) }
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .margin(topBottom = 10.px)
                                .classNames("chat-msg-enter"),
                            horizontalArrangement = if (msg.isUserMessage) Arrangement.End else Arrangement.Start,
                        )
                        {
                            if (!msg.isUserMessage) {
                                Image(
                                    src = Res.Images.assistAiMatt,
                                    modifier = Modifier.size(30.px)
                                        .borderRadius(100.px)
                                )
                                CustomSpacer(width = 10.px)
                            }
                            Column(
                                modifier = Modifier
                                    .maxWidth(80.percent)
                                    .backgroundColor(if (msg.isUserMessage) sitePalette.lightGrey.rgb else Colors.Transparent)
                                    .borderRadius(8.px)
                                    .then(
                                        if (!msg.isUserMessage && msg.pdfPayload != null) Modifier.border(
                                            width = 1.px,
                                            style = LineStyle.Solid,
                                            color = sitePalette.coachDetailsBoxBorder.rgb
                                        ) else Modifier
                                    )
                                    .position(Position.Relative)
                                    .padding(
                                        top = 8.px,
                                        bottom = 8.px,
                                        leftRight = 8.px
                                    )
                            ) {
                                // Action icons top-right (bot messages only)
                                if (!msg.isUserMessage) {
                                    Row(
                                        modifier = Modifier.fillMaxWidth()
                                            .right(8.px)
                                            .top(6.px)
                                            .gap(6.px),
                                        verticalAlignment = Alignment.CenterVertically,
                                        horizontalArrangement = Arrangement.End
                                    ) {

                                        // Download PDF icon (only if pdfPayload present)
                                        if (msg.pdfPayload != null) {
                                            CommonButton(
                                                loaderSize = 15.px,
                                                isLoading = isDownloading,
                                                width = 143.px,
                                                height = 25.px,
                                                icon = {
                                                    FaDownload(
                                                        modifier = Modifier.color(
                                                            sitePalette.bodyBackgroundSecondary.rgb
                                                        )
                                                    )
                                                },
                                                onCLick = {
                                                    scope.launch {
                                                        try {
                                                            isDownloading = true
                                                            generateChatbotReport(
                                                                DownloadPdfRequest(
                                                                    pdfPayload = msg.pdfPayload
                                                                )
                                                            )
                                                        } catch (ce: CancellationException) {
                                                            throw ce
                                                        } catch (e: Throwable) {
                                                            toastMessage("Something went wrong")
                                                            showToast(ToastID.ERROR)
                                                        } finally {
                                                            isDownloading = false
                                                        }
                                                    }
                                                },
                                                text = "Download PDF",

                                                )
                                        }
                                    }
                                }

                                if (msg.status.isNotBlank()) {
                                    CyclingThinkingIndicator(
                                        text = msg.status
                                    )
                                    Spacer()
                                }

                                if (msg.message.isNotBlank()) {
                                    MarkdownRenderer(
                                        text = msg.displayMessage ?: msg.message,
                                        isStreaming = msg.isStreaming,
                                        width = 100.percent,
                                        whiteSpace = WhiteSpace.Normal,
                                        fontSize = 16.px,
                                        fontFamily = Constants.IBM_FONT
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @Composable
    fun QuickActions(quickActionsHeight: CSSLengthOrPercentageNumericValue) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                modifier = Modifier
                    .size(34.px)
                    .borderRadius(10.px)
                    .backgroundColor(sitePalette.lightGrey.rgb),
                contentAlignment = Alignment.Center
            ) {
                Image(
                    src = Res.Images.action,
                    modifier = Modifier.size(20.px)
                )
            }
            FieldTitleTextNormalSimple(
                text = "Quick Actions",
                fontSize = 16.px,
                fontWeight = 500,
                marginLeft = 10.px
            )
            Spacer()
            // Dashboard Expand (in-place expand, same as DashboardChatbot)
            if (!isMobile) {
                if (!isChatOpen) {
                    if (isDashboardExpanded) {
                        Image(
                            src = Res.Images.down_arrow,
                            modifier = Modifier
                                .width(22.px)
                                .height(21.px)
                                .margin(right = 5.px)
                                .rotate(180.deg)
                                .cursor(Cursor.Pointer)
                                .onClick { onDashboardExpandToggle() }
                        )
                    } else {
                        Image(
                            src = Res.Images.down_arrow,
                            modifier = Modifier
                                .width(22.px)
                                .height(21.px)
                                .margin(right = 5.px)
                                .cursor(Cursor.Pointer)
                                .onClick { onDashboardExpandToggle() }
                        )
                    }
                }


                // Popup Expand (fullscreen overlay toggle)
                if (isChatOpen) {
                    FaXmark(
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick {
                                onExpandToggle()
                            },
                        size = IconSize.LG
                    )
                } else {
                    Image(
                        src = Res.Images.expandable,
                        modifier = Modifier.size(21.px).margin(right = 5.px)
                            .cursor(Cursor.Pointer)
                            .onClick { onExpandToggle() }
                    )
                }
            }
        }

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(quickActionsHeight)
                .margin(topBottom = 10.px)
                .padding(right = 10.px)
                .gap(10.px)
                .overflow(Overflow.Auto)
                .flexWrap(FlexWrap.Wrap)
                .transition(
                    Transition.of(
                        property = "height",  // ← SPECIFY PROPERTY
                        duration = 400.ms,
                        timingFunction = AnimationTimingFunction.EaseInOut
                    )
                )
        ) {
            quickCoachReportQuestions.forEach { (category, questions) ->
                Column(modifier = Modifier.fillMaxWidth()) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .backgroundColor(Colors.White)
                            .borderRadius(5.px)
                            .border(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = Colors.LightGray
                            )
                            .borderLeft(
                                width = 2.5.px,
                                style = LineStyle.Solid,
                                color = sitePalette.primary.rgb
                            )
                            .padding(leftRight = 12.px, topBottom = 9.px)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                expandedCategory =
                                    if (expandedCategory == category) null else category
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        Row(
                            modifier = Modifier.fillMaxSize(),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Column(modifier = Modifier.fillMaxWidth()) {
                                FieldTitleTextNormalSimple(
                                    category,
                                    fontSize = 14.px,
                                    fontWeight = 500,
                                    isClickable = true
                                )
                                FieldTitleTextNormalSimple(
                                    text = when {
                                        category.contains("Leadership & Identity") ->
                                            "Build your leadership style and impact"

                                        category.contains("Skill Development") ->
                                            "Design drills and training plans"

                                        category.contains("Mental Coaching & Support") ->
                                            "Support player confidence and mindset"

                                        category.contains("Physical Conditioning & Monitoring") ->
                                            "Track fitness, fatigue and recovery"

                                        category.contains("Match Planning & Strategy") ->
                                            "Plan roles and in-game strategy"

                                        category.contains("Targeted Training") ->
                                            "Personalize sessions to your squad"

                                        category.contains("Game Day Preparation") ->
                                            "Prepare players before kickoff"

                                        category.contains("Post-Game Analysis") ->
                                            "Review performance and recovery"

                                        else ->
                                            "Coaching guidance and insights"
                                    },
                                    fontSize = 12.px,
                                    color = Colors.Gray
                                )
                            }
                            Box(Modifier.weight(1f))
                            FaPlus(
                                size = IconSize.XS,
                                modifier = Modifier
                                    .transition(
                                        com.varabyte.kobweb.compose.css.Transition.Companion.of(
                                            TransitionProperty.All,
                                            400.ms
                                        )
                                    )
                                    .transform { rotate(if (expandedCategory == category) 90.deg else 0.deg) }
                                    .margin(left = 10.px)
                                    .color(sitePalette.primary.rgb)
                                    .align(Alignment.CenterVertically)
                            )
                        }
                    }

                    ExpandableContent(visible = expandedCategory == category) {
                        Row(
                            Modifier
                                .fillMaxWidth()
                                .flexWrap(FlexWrap.Wrap)
                                .margin(left = 10.px, top = 6.px, bottom = 12.px)
                                .gap(6.px)
                        ) {
                            questions.forEach { question ->
                                Box(
                                    Modifier
                                        .padding(6.px)
                                        .backgroundColor(Colors.White)
                                        .borderRadius(8.px)
                                        .cursor(if (isLoading || isButtonLoading || isQuickActionLoading) Cursor.NotAllowed else Cursor.Pointer)
                                        .border(1.px, LineStyle.Solid, sitePalette.primary.rgb)
                                        .onClick {
                                            if (isLoading || isButtonLoading) return@onClick
                                            handleUserMessage(
                                                question.query,
                                                isFromQuickAction = true,
                                                forceReport = question.forceReport,
                                                displayTitle = question.title
                                            )
                                        }
                                ) {
                                    FieldTitleTextNormalSimple(
                                        question.title,
                                        fontSize = 14.px,
                                        fontWeight = 400,
                                        isClickable = !(isLoading && isButtonLoading),
                                        isNotAllowed = isLoading || isButtonLoading || isQuickActionLoading
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @Composable
    fun InputArea(inputHeight: CSSLengthOrPercentageNumericValue, inputHeightStr: String) {
        Box(
            modifier = Modifier.fillMaxWidth().height(inputHeight).position(Position.Relative)
                .transition(
                    Transition.of(
                        property = "height",  // ← SPECIFY PROPERTY
                        duration = 400.ms,
                        timingFunction = AnimationTimingFunction.EaseInOut
                    )
                )
        ) {
            TextArea(
                attrs = Modifier.fillMaxWidth()
                    .border(0.px)
                    .backgroundColor(Colors.Transparent)
                    .toAttrs {
                        placeholder(
                            if (overLayOptions && getCoachInfo.payment.checkout.status != Strings.PAID) ""
                            else "Message AssistAI"
                        )
                        id(messageInputId)
                        style {
                            outline("none")
                            property("resize", "none")
                            property("font-family", Constants.IBM_FONT)
                            property("font-size", "16px")
                            property("width", "100%")
                            property("height", inputHeightStr)
                            property("box-sizing", "border-box")
                            property("padding", "8px 50px 8px 16px")
                            property("border-radius", "8px")
                            property("border", "1px solid ${sitePalette.coachDetailsBoxBorder.rgb}")
                            property("background-color", sitePalette.lightGrey.rgb.toString())
                            property("overflow-y", "auto")
                        }
                        attr("autocomplete", "off")
                        onInput { event ->
                            val inputField =
                                event.nativeEvent.target.unsafeCast<HTMLTextAreaElement>()
                            userInput = inputField.value
                        }
                        onKeyDown {
                            if (it.key == "Enter" && !it.shiftKey) {
                                it.preventDefault()
                                val inputField =
                                    document.getElementById(messageInputId) as? HTMLTextAreaElement
                                val message = inputField?.value.orEmpty()
                                if (message.isNotBlank() && !isButtonLoading && !overLayOptions && !isLoading && !isQuickActionLoading) {
                                    handleUserMessage(message, isFromQuickAction = false)
                                }
                            }
                        }
                    }
            )

            if (!overLayOptions) {
                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .bottom(11.px)
                        .right(11.px)
                        .zIndex(2)
                ) {
                    val isSendDisabled =
                        isButtonLoading || userInput.isBlank() || isLoading || isQuickActionLoading

                    if (isButtonLoading) {
                        Box(
                            modifier = Modifier.size(40.px)
                                .borderRadius(100.percent)
                                .backgroundColor(sitePalette.primary.rgb),
                            contentAlignment = Alignment.Center
                        ) {
                            ProgressIndicator()
                        }
                    } else {
                        Image(
                            src = Res.Images.send_Button,
                            modifier = Modifier
                                .size(40.px)
                                .cursor(if (isSendDisabled) Cursor.NotAllowed else Cursor.Pointer)
                                .opacity(if (isSendDisabled) 0.5f else 1f)
                                .onClick {
                                    if (!isSendDisabled) {
                                        val inputField =
                                            document.getElementById(messageInputId) as? HTMLTextAreaElement
                                        val message = inputField?.value.orEmpty()
                                        handleUserMessage(message, isFromQuickAction = false)
                                    }
                                }
                        )
                    }
                }
            }

            if (overLayOptions) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .position(Position.Absolute)
                        .zIndex(9)
                        .backgroundColor(Colors.Gray.copyf(alpha = 0.2f))
                        .borderRadius(8.px),
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        Modifier.fillMaxWidth(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        val overlayMessage: String
                        val shouldShowSubscribeButton: Boolean

                        when {
                            isIndependentCoach && (!isCoachPaid || !isCoachUnexpired) && questionLimitReached -> {
                                overlayMessage =
                                    "Free questions limit reached. Get Subscription to continue using AssistAI"
                                shouldShowSubscribeButton = true
                            }

                            AppGlobal.userData.role == Strings.ADMIN && (!isClubPaid || !isClubUnexpired) && questionLimitReached -> {
                                overlayMessage =
                                    "Your subscription has expired. Please renew to continue using AssistAI."
                                shouldShowSubscribeButton = false
                            }

                            !isIndependentCoach && (!isClubPaid || !isClubUnexpired) && questionLimitReached -> {
                                overlayMessage =
                                    "Your club subscription has expired. Please contact your club administrator to renew the subscription. Thank you!"
                                shouldShowSubscribeButton = false
                            }

                            else -> {
                                overlayMessage =
                                    "Note: Coach profile should be complete to use AssistAI"
                                shouldShowSubscribeButton = false
                            }
                        }

                        if (shouldShowSubscribeButton) {
                            CommonButton(
                                text = "Subscribe",
                                onCLick = { subscriptionPopup(true) },
                                width = 80.px,
                                height = 36.px
                            )
                            CustomSpacer(height = 10.px)
                        }

                        FieldTitleTextNormalSimple(
                            text = overlayMessage,
                            fontSize = if (shouldShowSubscribeButton) 12.px else 14.px,
                            textAlign = TextAlign.Center,
                            width = 100.percent,
                            whiteSpace = WhiteSpace.PreWrap,
                        )
                    }
                }
            }
        }
    }

    // ── Height calculations — driven by isChatOpen (popup/fullscreen) & isDashboardExpanded ──
    val rootHeight: CSSLengthOrPercentageNumericValue = when {
        isChatOpen -> 800.px
        isDashboardExpanded -> 760.px
        else -> 435.px
    }

    val chatMessagesHeightMobile: CSSLengthOrPercentageNumericValue = when {
        isChatOpen -> 640.px
        isDashboardExpanded -> 650.px
        else -> 360.px
    }

    val chatMessagesHeightDesktop: CSSLengthOrPercentageNumericValue = when {
        isChatOpen -> 700.px
        isDashboardExpanded -> 650.px
        else -> if (breakpoint == Breakpoint.MD || breakpoint == Breakpoint.LG) 310.px else 325.px
    }

    val quickActionsHeight: CSSLengthOrPercentageNumericValue = when {
        isChatOpen -> 465.px
        isDashboardExpanded -> 450.px
        else -> if (isMobile) 133.px else 185.px
    }

    val inputHeight: CSSLengthOrPercentageNumericValue = when {
        isChatOpen -> 250.px
        isDashboardExpanded -> 220.px
        else -> if (isMobile) 95.px else 160.px
    }
    val inputHeightStr: String = when {
        isChatOpen -> "250px"
        isDashboardExpanded -> "220px"
        else -> if (isMobile) "95px" else "160px"
    }

    // ── Root container ───────────────────────────────────────────────────────
    Box(
        modifier = Modifier
            .margin(topBottom = 10.px)
            .fillMaxWidth()
            // Fixed height on desktop; auto (wrap content) on mobile — unless popup/expanded
            .then(
                if (isMobile && !isChatOpen && !isDashboardExpanded) Modifier
                else Modifier.height(rootHeight)
            )
            .transition(
                Transition.of(TransitionProperty.All, 400.ms, AnimationTimingFunction.EaseInOut)
            )
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .boxShadow(offsetY = 1.px, blurRadius = 3.px, color = sitePalette.boxShadowColor.rgb)
            .borderRadius(15.px)
            .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
    ) {
        Box(modifier = Modifier.fillMaxWidth().fillMaxHeight().position(Position.Relative)) {
            Column(
                modifier = Modifier.fillMaxSize()
                    .padding(topBottom = 16.px, leftRight = 24.px)
            ) {
                if (isMobile) {
                    // ── MOBILE: single column, quick-actions wrap below chat ──────────
                    Header()
                    ChatMessages(chatHeight = chatMessagesHeightMobile)
                    QuickActions(quickActionsHeight = quickActionsHeight)
                    InputArea(inputHeight = inputHeight, inputHeightStr = inputHeightStr)
                } else {
                    // ── DESKTOP: 69% chat | 29% quick-actions + input ────────────────
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        // Left: header + chat
                        Column(
                            modifier = Modifier.fillMaxWidth(
                                if (breakpoint == Breakpoint.MD) 65.percent else 69.percent
                            )
                        ) {
                            Header()
                            ChatMessages(chatHeight = chatMessagesHeightDesktop)
                        }

                        // Right: quick actions + textarea
                        Column(
                            modifier = Modifier.fillMaxWidth(
                                if (breakpoint == Breakpoint.MD) 35.percent else 29.percent
                            )
                        ) {
                            QuickActions(quickActionsHeight = quickActionsHeight)
                            InputArea(inputHeight = inputHeight, inputHeightStr = inputHeightStr)
                        }
                    }
                }
            }
        }
    }
}
